module.exports = "/_next/static/images/96bfb2f144befcaff2e634f31ac396cf-app-screenshots-lg@2x.jpg.webp";